// GENERATED FILE - DO NOT MODIFY
export enum PhysicalInventoryMobileStatus {
    Active = "0",
    Completed = "1",
    Confirmed = "P",
}

export let nameof = "PhysicalInventoryMobileStatus";
